import { Component, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { Router } from "@angular/router";
import { AuthService } from "../auth.service";
import { DataServiceService } from "../data-service.service";
import {
  ADVERSE_MEDIA_CATEGORIES,
  getAdverseMediaCategoryLabel,
  getAdverseMediaCategoryReturnedCount,
  getAdverseMediaTotalReturnedCount,
} from "../utils/adverse-media-utils";
import { goBackToHistory } from "../utils/history-navigation-utils";

@Component({
  selector: "app-result-adverse-media",
  templateUrl: "./result-adverse-media.component.html",
  styleUrls: ["./result-adverse-media.component.scss"],
})
export class ResultAdverseMediaComponent implements OnInit {
  adverseMediaData: any;
  searchedName = "";
  categoryList = ADVERSE_MEDIA_CATEGORIES;
  totalHits = 0;
  showSuccessMsg = false;
  isSavingRecord = false;
  isHistoryView = false;

  constructor(
    private location: Location,
    private router: Router,
    private authService: AuthService,
    private dataService: DataServiceService,
  ) {}

  ngOnInit(): void {
    this.isHistoryView =
      sessionStorage.getItem("historyDetailFromHistory") === "true";
    this.searchedName = localStorage.getItem("adverseMediaSearchedName") || "";
    const stored = localStorage.getItem("adverseMediaData");
    this.adverseMediaData = stored ? JSON.parse(stored) : null;

    if (!this.adverseMediaData) {
      return;
    }
    this.totalHits = getAdverseMediaTotalReturnedCount(this.adverseMediaData);
  }

  goBack() {
    if (sessionStorage.getItem("historyDetailFromHistory") === "true") {
      goBackToHistory(this.location);
      return;
    }
    localStorage.setItem("skipSearchOnBack", "true");
    localStorage.setItem("skipSearchOnBackTs", Date.now().toString());
    this.location.back();
  }

  getCategoryLabel(key: string): string {
    return getAdverseMediaCategoryLabel(key);
  }

  getCategoryExposure(key: string) {
    return this.adverseMediaData?.news_exposures?.[key] || null;
  }

  getCategoryReturnedHits(key: string): number {
    return getAdverseMediaCategoryReturnedCount(this.getCategoryExposure(key));
  }

  showCategoryDetails(categoryKey: string) {
    if (this.getCategoryReturnedHits(categoryKey) <= 0) {
      return;
    }

    localStorage.setItem("adverseMediaCategory", categoryKey);
    this.router.navigate(["/result-adverse-media-category"]);
  }

  openSearchResultsReport() {
    if (!this.adverseMediaData) {
      return;
    }
    localStorage.removeItem("mediaReportHistoryData");
    this.router.navigate(["/new-print-media"]);
  }

  saveRecord() {
    if (this.isSavingRecord || !this.adverseMediaData) {
      return;
    }

    this.isSavingRecord = true;
    const currentDate = new Date();
    const historyObj: any = {};
    historyObj["userEmail"] = this.authService.getCurrentUser().email;

    const recordJson: any = {
      name: this.searchedName,
      searchedName: this.searchedName,
      timestamp: this.adverseMediaData.timestamp || "",
      news_exposures: this.adverseMediaData.news_exposures || {},
      adverseMediaData: this.adverseMediaData,
      totalHits: this.totalHits,
      totalMatches: this.totalHits,
      hongKongDT: localStorage.getItem("searchDateAndTime") || "",
      typeOfSearch: localStorage.getItem("searchType") || "",
      entityGender: localStorage.getItem("gender") || "NO",
      entityDD: localStorage.getItem("dd") || "00",
      entityMM: localStorage.getItem("mm") || "00",
      entityYYYY: localStorage.getItem("yyyy") || "0000",
    };
    recordJson["saveDate"] = `${currentDate.getDate()}/${
      currentDate.getMonth() + 1
    }/${currentDate.getFullYear()}`;
    recordJson["saveTime"] = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    recordJson["UTCsaveDate"] = `${currentDate.getUTCDate()}/${
      currentDate.getUTCMonth() + 1
    }/${currentDate.getUTCFullYear()}`;
    recordJson[
      "UTCsaveTime"
    ] = `${currentDate.getUTCHours()}:${currentDate.getUTCMinutes()}:${currentDate.getUTCSeconds()}`;
    recordJson["type"] = "ADVERSE_MEDIA";

    historyObj["historyData"] = [recordJson];

    this.dataService
      .saveAdverseMediaHistory(historyObj)
      .then((data) => {
        if (data["msg"] == "Saved record") {
          this.isSavingRecord = false;
          this.showSuccessMsg = true;
          setTimeout(() => {
            this.showSuccessMsg = false;
          }, 5000);
        } else {
          this.isSavingRecord = false;
          alert("Failed to save record. Please try after some time");
        }
      })
      .catch((error) => {
        this.isSavingRecord = false;
        if (error && error.statusText && error.statusText.indexOf("Too Large") > -1) {
          alert(
            "The search report file is too large to save in iKYC, we suggest you print or save the report in your local drive, should you have any questions, please feel tree to contact us at info@kcgleads.com, we will get back to you within 24 hours",
          );
        } else {
          alert("Failed to save record. Please try after some time");
        }
      });
  }
}
